/** @jsxImportSource @emotion/react */
import { Box, css } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Header from '../Types/header';

const MainHeader = (props: { data: Header[] }) => {
  const { data } = props;

  const [selectedHeader, setSelectedHeader] = useState<string>('');

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!!selectedHeader && selectedHeader !== '') return;
    const decode = decodeURI(location.search).replace('?', '');
    console.log(decode);
    const d = document.getElementById(`headerItem-${decode}`);

    if (!!d) {
      d.click();
    } else {
      setSelectedHeader(decodeURI(location.pathname.replace('/', '')));
    }
  }, [data]);

  const handleNav = (d: string) => {
    if (!!d && d !== '') {
      navigate(`/${d}`);
      setSelectedHeader(d);
    }
  };

  return (
    <React.Fragment>
      <Box
        css={style.title}
        // onClick={handleNav.bind(this, '')}
      >
        SampleBook
      </Box>
      <Box css={style.headerBox}>
        {data.map((d) => {
          return (
            <div id={`headerItem-${d.name}`} onClick={handleNav.bind(this, d.name)} css={[style.header, selectedHeader === d.name && style.selected]} key={d.id}>
              {d.name}
            </div>
          );
        })}
      </Box>
    </React.Fragment>
  );
};

const style = {
  title: css`
    font-weight: bold;
    width: 100%;
    font-size: 32px;
    justify-content: center;
    display: flex;
    align-items: center;
    margin: 16px auto;
    cursor: default;
  `,
  headerBox: css`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  `,
  header: css`
    display: flex;
    border: 1px solid black;
    margin: 0 4px;
    width: calc(100% / 8 - 8px);
    justify-content: center;
    align-items: center;
    padding: 8px 0px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 0px 3px black;
    }
    @media (max-width: 592px) {
      width: calc(100% / 4 - 8px);
      margin-top: 4px;
    }
  `,
  selected: css`
    background-color: #ffff0080;
  `,
};

export default MainHeader;
